import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {
  citiesEnum,
  ICurator,
  IDeveloper,
  IObject,
  IRegion,
  ISpot,
  RoomType,
  SetBuilding,
  SpotRank,
  SupervisorInfo,
  WallMaterialType
} from '../../../shared/models/models';
import {ActivatedRoute, Router} from '@angular/router';
import {ServerService} from '../../../shared/services/server.service';
import {EventService} from '../../../shared/services/event.service';
import {UserInfo} from '../../header/header.component';
import {environment} from '../../../../environments/environment';
import {ToastrService} from 'ngx-toastr';

import * as moment from 'moment';
import {companyName} from '../../../shared/global';
import {IOrganizationTypeShortName} from '../../select-item/organizations.service';
import {IMapControlResult, LeafletDialogComponent} from "../../leaflet-dialog/leaflet-dialog.component";
import {MatDialog} from "@angular/material/dialog";

@Component({
  selector: 'app-object-information',
  templateUrl: './object-information.component.html',
  styleUrls: ['./object-information.component.scss']
})
export class ObjectInformationComponent implements OnInit {

  citiesEnum = citiesEnum;
  companyName = companyName;

  public api = environment.apiUrl;

  object: IObject = null;
  loading: boolean = false;
  updateLoading: boolean = false;

  // WallMaterials
  wallMaterialTypes: WallMaterialType[] = [];
  // RoomTypes
  buildingRoomTypes: RoomType[] = [];
  //BuildingClasses
  buildingClasses: SpotRank[] = [];

  // Modal Windows
  cityModal: boolean = false;
  locationModal: boolean = false;
  startCalendarModal: boolean = false;
  delayModal: boolean = false;
  endCalendarModal: boolean = false;
  logModal: boolean = false;
  bdInvCost_ConstrWork: boolean = false;
  bdInvCost_TechnicalSuperv: boolean = false;

  developerModal: boolean = false;
  developerModalTitle: string = '';
  developerCurrentKey: string = '';
  developerItems: IDeveloper[] = [];
  regionID: number = null;

  // Edited Fields
  objectNameLoading: boolean = false;
  ownInvestmentsLoading: boolean = false;
  estimateCost: boolean = false;
  bdInvestmentsLoading: boolean = false;
  ownInvestmentsLoading2: boolean = false;
  bdInvestmentsLoading2: boolean = false;
  implementationAmountLoading: boolean = false;
  countOfFlats: boolean = false;
  countOfFlats1: boolean = false;
  bD_FlatArea: boolean = false;
  pP_FlatArea: boolean = false;
  bdInvCost_AuthorSuperv: boolean = false;

  bdInvCost_AddExp: boolean = false;
  ppInvCost_AddExp: boolean = false;

  paramsID: number;
  ppInvCost_ConstrWork: boolean = false;
  ppInvCost_AuthorSuperv: boolean = false;
  ppInvCost_TechnicalSuperv: boolean = false;
  guarantObligationPercent: boolean = false;
  bD_FlatCount: boolean = false;
  pP_FlatCount: boolean = false;
  // uniqueCurators: ICurator[] = [];
  paragraph16: number = 0;
  paragraph17: number = 0;
  cadastralToggle: boolean = false;

  landPlotType: boolean = false;

  file6: any = null;

  durationLoading: boolean = false;

  mapZoom: number = 8;

  actModal: boolean = false;

  styles = [
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on'
        },
        {
          lightness: 33
        }
      ]
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          color: '#f2e5d4'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [
        {
          color: '#c5dac6'
        }
      ]
    },
    {
      featureType: 'poi.park',
      elementType: 'labels',
      stylers: [
        {
          visibility: 'on'
        },
        {
          lightness: 20
        }
      ]
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          lightness: 20
        }
      ]
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [
        {
          color: '#c5c6c6'
        }
      ]
    },
    {
      featureType: 'road.arterial',
      elementType: 'geometry',
      stylers: [
        {
          color: '#e4d7c6'
        }
      ]
    },
    {
      featureType: 'road.local',
      elementType: 'geometry',
      stylers: [
        {
          color: '#fbfaf7'
        }
      ]
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on'
        },
        {
          color: '#acbcc9'
        }
      ]
    }
  ];
  actCalendar: boolean = false;
  disCalendar: boolean = false;
  public user: UserInfo = null;
  landPlotTypeCalendar: boolean = false;
  userName: string = '';
  //public apartment_number: number = 0;
  mioReadOnlyUserFlag: boolean = false;
  error409: boolean;
  timestamp: any;
  authOrganization: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private serverService: ServerService,
    private eventService: EventService,
    private router: Router,
    public toastr: ToastrService,
    public dialog: MatDialog
  ) {
    let user = localStorage.getItem('user');
    if (user) {
      this.user = JSON.parse(user);
      if (this.user.roles.some((e) => e === 'MioReadOnlyUser')) {
        this.mioReadOnlyUserFlag = true;
      }
    }
  }

  addObject;
  addObjectLog: boolean = false;
  validRegion: boolean = false;

  get expertiseBtnIsActive() {
    return this.isObjectValid || this.isSetObject;
  }

  ngOnInit() {
    this.init();
    this.eventService.duplicateBuildiung.subscribe(res => {
      if (res) {
        this.init();
      }
    });
  }

  init() {
    this.addObject = localStorage.getItem('addobj');
    if (this.addObject) {
      this.addObjectLog = true;
    }
    if (this.wallMaterialTypes.length == 0) {
      this.serverService.getWallMaterialTypes().then((res) => {
        this.wallMaterialTypes = res;
        this.getWallMaterialItems(this.wallMaterialTypes);
      });
    }
    if (this.buildingRoomTypes.length == 0) {
      this.serverService.getBuildingRoomTypes().then((res) => {
        this.buildingRoomTypes = res;
        this.getBuildingOtherRooms(this.buildingRoomTypes);
      });
    }
    if (this.buildingClasses.length == 0) {
      this.serverService.getBuildingClasses().then((res) => {
        this.buildingClasses = res;
      });
    }

    this.route.parent.params.subscribe((params) => {
      this.paramsID = params.id;
      if (params.id > 0) {
        this.getObject(params);
      } else {
        // this.apartment_number = 0;
        let user = localStorage.getItem('user');
        if (user) {
          this.user = JSON.parse(user);
        }
        let respMio = this.user.mio.length == 0 ? {id: null, bin: null, name: ''} : this.user.mio[0];
        this.regionID = null;
        if (this.user.roles.some((e) => e === 'MioUser')) {
          this.userName = 'MioUser';
        }
        this.object = {
          id: this.paramsID,
          name: '',
          duration: 0,
          development_start_date: null,
          development_end_date: null,
          region: null,
          city: null,
          finances: null,
          latitude: null,
          longitude: null,
          investments: {
            own_investments: null,
            bd_investments: null,
            own_investments2: null,
            bd_investments2: null,
            implementation_amount: null
          },
          curators: [],
          developer: {
            responsible: respMio,
            general_contractor: null,
            author_supervision: null,
            technical_supervision: null,
            supervisor: null,
            private_partner: null,
            authorized_organization: null
          },
          flatRealization: [],
          spots: [],
          remove_spot_ids: [],
          total_flat_count: 0,
          sales_flat_count: 0,
          completion_percent: 0,
          buildingDocumentsCount: 0,
          portalID: 1,
          bdInvCost_AuthorSuperv: 0,
          bdInvCost_ConstrWork: 0,
          bdInvCost_TechnicalSuperv: 0,
          ppInvCost_ConstrWork: 0,
          ppInvCost_TechnicalSuperv: 0,
          ppInvCost_AuthorSuperv: 0,
          bdInvCost_AddExp: 0,
          ppInvCost_AddExp: 0,
          bD_FlatArea: 0,
          pP_FlatArea: 0,
          bD_FlatCount: 0,
          pP_FlatCount: 0,
          leaseExpDate: null,
          cadastral: null
        };
        // this.uniqueCurators = [];

        if (
          this.user.roles.some((e) => e === 'MioUser') ||
          this.user.roles.some((e) => e === 'MioRegionAdministrator')
        ) {
          this.object.developer.responsible = respMio;
          this.object.region = this.user.region[0];
        }

        this.loading = true;
        this.objectNameLoading = true;
        this.ownInvestmentsLoading = true;
        this.bdInvestmentsLoading = true;
        this.ownInvestmentsLoading2 = true;
        this.bdInvestmentsLoading2 = true;
        this.implementationAmountLoading = true;

      }
    });
  }


  Doc4: boolean = false;
  Doc5: boolean = false;
  Doc9: boolean = false;
  file7 = null;
  contract: boolean = false;

  getObject(params) {
    this.serverService.getObject(params.id).then((res) => {
      this.object = res;
      this.validRegion = this.object.city && this.object.city.id != null;
      this.timestamp = res.timestamp;

      this.eventService.countObject.emit(this.object.counter);

      if (this.object.landPlotTypeID === 2) {
        this.landPlotType = true;
      }

      this.object.docs.map((r) => {
        if (r.documentTypeID === 6) {
          this.contract = true;
        }
      });

      this.object.docs.map((r) => {
        if (r.documentTypeID === 1) {
          this.file1 = r.fileName;
        }
        if (r.documentTypeID === 2) {
          this.file2 = r.fileName;
        }

        if (r.documentTypeID === 6) {
          this.file6 = r.fileName;
        }

        if (r.documentTypeID === 7) {
          this.file7 = r.fileName;
        }
      });
      for (let i = 0; i < this.object.docs.length; i++) {
        if (this.object.docs[i].documentTypeID === 1) {
          this.Doc4 = true;
        }
        if (this.object.docs[i].documentTypeID === 2) {
          this.Doc5 = true;
        }
      }
      this.object.spots.forEach((s) => {
        this.serverService.getSpotActDoc(s.id).then((r1) => {
          s.docs = r1;
          if (s.docs.length !== 0) {
            this.Doc9 = true;
          }
        });
      });

      if (this.object.region.id > 0) {
        this.regionID = this.object.region.id;
      }
      this.object.spots.forEach((s) => {
        this.serverService.getSpotActDoc(s.id).then((r1) => {
          s.docs = r1;
          if (s.docs.length === 0) {
            s.calendarActVis = true;
          }
        });
      });
      if (!this.object.curators) {
        this.object.curators = [];
      }
      // this.uniqueCurators = this.getUniqueObjectCurators(this.object.curators);

      // let user = localStorage.getItem('user');
      // if (user) {
      //     this.user = JSON.parse(user);
      //     let respMio = this.user.mio.length == 0 ? {id: null, name: ''}: this.user.mio[0];
      //     if (this.user.role == 'MioUser' || this.user.role == 'MioRegionAdministrator') {
      //         this.object.developer.responsible = respMio;
      //         this.object.region = this.user.region[0];
      //     }
      // }

      // if(this.object.spots !== null){
      //     this.object.spots.forEach(s => {
      //         this.apartment_number = this.apartment_number + s.apartment_number;
      //     });
      // }

      this.loading = true;
      //
      // if (this.object.latitude == null || this.object.latitude == 0) {
      //   if (this.object.region && this.object.city) {
      //     this.serverService.getLocation(this.object.region.name + 'область, город ' + this.object.city.name).then(res => {
      //       if (res.results.length > 0) {
      //         this.object.latitude = res.results[0].geometry.location.lat;
      //         this.object.longitude = res.results[0].geometry.location.lng;
      //       } else {
      //         this.object.latitude = 48.7346586;
      //         this.object.longitude = 67.3090432;
      //         this.mapZoom = 4.5;
      //       }
      //       this.loading = true;
      //     });
      //   } else {
      //     this.object.latitude = 48.7346586;
      //     this.object.longitude = 67.3090432;
      //     this.mapZoom = 4.5;
      //     this.loading = true;
      //   }
      // }

      this.object.remove_spot_ids = [];
    });
  }

  selectedSpotIndexToUp: number;

  uploadSpotActDocument(event, fileTypeId: number, spotId: number, spot, spotDoc) {
    let files = event;
    this.selectedSpotIndexToUp = spot;
    for (let i = 0; i < files.length; i++) {
      let fileType = files[i].type.substr(files[i].type.indexOf('/') + 1);
      this.serverService.uploadSpotActDocument(spotId, fileTypeId, files[i]).then((res) => {
        spotDoc.disCalendar = true;
        spotDoc.docs.push({
          dbFileID: res[0],
          documentTypeID: fileTypeId,
          fileExtension: '',
          fileName: res[0] + '.' + fileType,
          updatedOn: ''
        });
      });
    }
  }

  spotDocDate: number;

  sendActDate() {
    let currentDate = moment(this.spotDocDate).format('YYYY-MM-DD');

    this.serverService
      .setActDate(this.object.spots[this.selectedSpotIndexToUp].docs[0].dbFileID, currentDate)
      .then((r) => {
        this.object.spots[this.selectedSpotIndexToUp].calendarActVis = false;
      });
  }

  deleteActDocument(fileID: number, file, spot) {
    this.serverService.delActFile(fileID).then((r) => {
      file.pop();
      spot.calendarActVis = true;
      spot.disCalendar = false;
    });
  }

  getBuildingOtherRooms(building_rooms: RoomType[]) {
    for (let item of building_rooms) {
      this.serverService.getBuildingRooms(item.id).then((resp) => {
        item.type = resp;
        item.modal = false;
      });
    }
  }

  getWallMaterialItems(materials: WallMaterialType[]) {
    for (let item of materials) {
      this.serverService.getWallMaterials(item.id).then((resp) => {
        item.wall_material = resp;
        for (let material of item.wall_material) {
          material.checked = false;
        }
        item.active = item.id === 1;
      });
    }
  }

  getUniqueObjectCurators(curators: ICurator[]) {
    let arr: ICurator[] = [];
    curators.map((res) => {
      if (arr.findIndex((r) => r.userId === res.userId) == -1) {
        arr.push(res);
      }
    });
    return arr;
  }

  openCollapse(id: number) {
    for (var i = 0; i < this.object.spots.length; i++) {
      if (i != id) this.object.spots[i].isOpen = false;
    }
    this.object.spots[id].isOpen = !this.object.spots[id].isOpen;
  }

  getColor(percent: number): string {
    if (percent === 100) {
      return 'realize';
    } else if (percent === 0 || percent == null) {
      return 'commonly';
    } else {
      return 'exploitation';
    }
  }

  addSpot() {
    if (this.object.id !== 0) {
      let new_spot = {
        id: 0,
        number: '',
        floors: null,
        apartment_number: 0,
        developer_id: 0,
        developer_title: '',
        total_area: 0,
        rank: '',
        rank_id: 0,
        homeNumber: '',
        hasMansard: false,
        totalFlatAmount: null,
        totalFlatArea: 0,
        realisationPercent: 0,
        residueFlatCount: 0,
        isOpen: false
      };
      this.object.spots.push(new_spot);

      this.updateLoading = true;
      let building: SetBuilding = {
        LivingComplexID: this.object.id,
        BuildingNumber: null,
        FloorCount: 0,
        FlatCount: 0,
        HomeNumber: null,
        HasMansard: false
      };
      this.serverService.setBuilding(building).then((res) => {
        new_spot.id = res;
        this.updateLoading = false;
      });
    }
  }

  openConfirmDialog: boolean = false;
  spotEx: ISpot;
  deleteType: string | any = '';

  removeSpot(spot: ISpot) {
    this.openConfirmDialog = true;
    this.spotEx = spot;
    this.deleteType = 'spot';
  }

  acceptRemove(confirmAnswer: string) {
    if (this.deleteType === 'spot') {
      if (confirmAnswer === 'yes') {
        let i = this.object.spots.indexOf(this.spotEx);
        if (i != -1) {
          this.object.remove_spot_ids.push(this.object.spots[i].id);
          this.object.spots.splice(i, 1);
          this.openConfirmDialog = false;
        }
      }
      if (confirmAnswer === 'no') {
        this.openConfirmDialog = false;
      }
    }
    if (this.deleteType === 'file') {
      if (confirmAnswer === 'yes') {
        this.serverService.deleteObjectDocument(this.document).then((res) => {
          let index;
          for (let i = 0; i < this.object.docs.length; i++) {
            if (this.document === this.object.docs[i].dbFileID) {
              index = i;
            }
          }
          this.object.docs.splice(index, 1);
        });
        this.openConfirmDialog = false;
      }
      if (confirmAnswer === 'no') {
        this.openConfirmDialog = false;
      }
    }
    if (this.deleteType === 'fileAct') {
      if (confirmAnswer === 'yes') {
        this.serverService.deleteObjectDocumentAct(this.document.dbFileID).then((res) => {
          let find = this.object.docs.filter((d) => d.dbFileID == this.document.dbFileID);
          if (find) {
            let index = this.object.docs.indexOf(find[0]);
            this.object.docs.splice(index, 1);
          }
        });
        this.openConfirmDialog = false;
      }
    }
    if (confirmAnswer === 'no') {
      this.openConfirmDialog = false;
    }
  }

  setFieldValue(loading: string, event) {
    if (event.keyCode == 13) {
      this[loading] = false;
    }
  }

  editObjectName() {
    if (this.objectNameLoading) {
      this.objectNameLoading = false;
    } else {
      this.objectNameLoading = true;
    }
  }

  changeObjectName(name: string) {
    this.eventService.changeObjectNameEvent.emit(name);
  }

  getDate(timestamp: number) {
    let date = new Date(timestamp);
    return date.getDate() + ' ' + this.getMonthName(date) + ' ' + date.getFullYear() + 'г.';
  }

  getPlus9Month(timestamp: number, duration: number) {
    let date = new Date(timestamp);
    date.setMonth(date.getMonth() + duration);
    return date.getDate() + ' ' + this.getMonthName(date) + ' ' + date.getFullYear() + 'г.';
  }

  getMonthName(date: Date) {
    return this.eventService.getMonthName(date.getMonth() + 1, true, true);
  }

  selectRegion() {
    if (this.object.region) {
      this.object.developer.supervisor =
        this.regionID === this.object.region.id ? this.object.developer.supervisor : null;
    }
    this.regionID = this.object.region.id;
  }

  // TODO: удалить
  // openDeveloperModal_Old(key: string) {
  // 	this.developerCurrentKey = key;
  // 	if (key == 'responsible') {
  // 		this.developerModalTitle = 'Ответственный';
  // 		this.serverService.getMIOs().then((res) => {
  // 			this.developerItems = res;
  // 			this.developerModal = true;
  // 		});
  // 	} else if (key == 'general_contractor') {
  // 		this.developerModalTitle = 'Подрядчик';
  // 		this.serverService.getGeneralContractors().then((res) => {
  // 			this.developerItems = res;
  // 			this.authOrganization = true;
  // 			this.developerModal = true;
  // 		});
  // 	} else if (key == 'authorized_organization') {
  // 		this.developerModalTitle = 'Уполномоченная компания';
  // 		this.serverService.getGetAuthCompanies().then((res) => {
  // 			this.developerItems = res;
  // 			this.authOrganization = false;
  // 			this.developerModal = true;
  // 		});
  // 	}
  // 	else if (key == 'author_supervision') {
  // 		this.developerModalTitle = 'Авторский надзор';
  // 		this.serverService.getAuthorSupervisions().then((res) => {
  // 			this.developerItems = res;
  // 			this.developerModal = true;
  // 		});
  // 	} else if (key == 'technical_supervision') {
  // 		this.developerModalTitle = 'Технический надзор';
  // 		this.serverService.getTechnicalSupervisions().then((res) => {
  // 			this.developerItems = res;
  // 			this.developerModal = true;
  // 		});
  // 	} else if (key == 'supervisor') {
  // 		this.developerModalTitle = 'Супервайзер';
  // 		this.serverService.getSupervisors(this.regionID).then((res) => {
  // 			this.developerItems = res;
  // 			this.developerModal = true;
  // 		});
  // 	} else if (key == 'private_partner') {
  // 		this.developerModalTitle = 'Частный партнер';
  // 		this.serverService.getOwnPartners().then((res) => {
  // 			this.developerItems = res;
  // 			this.developerModal = true;
  // 		});
  // 	} else if (key == 'curators') {
  // 		this.developerModalTitle = 'Кураторы';
  // 		this.serverService.getCurators().then((res) => {
  // 			console.log(`=== res = `, res);
  //       this.developerItems = res;
  // 			this.developerModal = true;
  // 		});
  // 	}
  // 	return true;
  // }


  openDeveloperModal(key: IOrganizationTypeShortName) {
    this.developerCurrentKey = key;
    this.developerModalTitle = SupervisorInfo[key];
    this.developerModal = true;
    return true;
  }


  updateDeveloperByKey(event) {
    this.object.developer[event.key] = event.value;
    this.developerModal = false;
  }

  isObjectValid(obj: IObject): boolean {
    return Boolean(
      obj.name &&
      obj.city &&
      obj.development_start_date &&
      obj.duration &&
      obj.developer?.general_contractor &&
      obj.developer?.author_supervision &&
      obj.developer?.technical_supervision
    );
  }



  isSetObject = false;
  setObject() {
    if (!this.object.developer) {
      this.object.developer = {
        responsible: null,
        general_contractor: null,
        author_supervision: null,
        technical_supervision: null,
        supervisor: null,
        authorized_organization: null,
      }
    }

    localStorage.removeItem('addobj');
    if (!this.object.name) {
      alert('Заполните поле "Наименование объекта"');
      return false;
    }

    if (!this.object.city) {
      alert('Заполните поле "Область / Город"');
      return false;
    }

    if (!this.object.development_start_date) {
      alert('Не выбран "Дата начала СМР"');
      return false;
    }

    if (!this.object.duration) {
      alert('Заполните поле "Нормативная продолжительность строительства"');
      return false;
    }

    if (!this.object.developer.general_contractor) {
      alert('Не выбран "Генеральный подрядчик"');
      return false;
    }

    if (!this.object.developer.author_supervision) {
      alert('Не выбран "Авторский надзор"');
      return false;
    }

    if (!this.object.developer.technical_supervision) {
      alert('Не выбран "Технический надзор"');
      return false;
    }

    if (this.object.investments.implementation_amount) {
      if (this.object.investments.implementation_amount.toString().indexOf(',') > -1) {
        let val = this.object.investments.implementation_amount.toString().substring(0, this.object.investments.implementation_amount.toString().indexOf(",") + 3);
        this.object.investments.implementation_amount = parseFloat(val.replace(',', '.'));
      }
      if (this.object.investments.implementation_amount.toString().indexOf('.') > -1) {
        let val = this.object.investments.implementation_amount.toString().substring(0, this.object.investments.implementation_amount.toString().indexOf(".") + 3);
        this.object.investments.implementation_amount = parseFloat(val);
      }
    }

    if (this.object.id == 0) {
      delete this.object.id;
    }

    this.updateLoading = true;
    for (let spots of this.object.spots) {
      delete spots.isOpen;
      delete spots.commercialRooms;
      delete spots.auxiliaryRooms;
      delete spots.parkingRooms;
      delete spots.wallMaterials;
      delete spots.spotRanks;
      delete spots.apartmentCount;
      delete spots.countRoomsOfFloor;
      delete spots.apartmentScheme;
      delete spots.countRooms;
      delete spots.mansardRooms;
      delete spots.flatRealization;
      delete spots.flatConfiguration;
    }
    this.object.timestamp = this.timestamp;
    if (this.object.bD_FlatArea) {
      let bdflatAreathis = this.object.bD_FlatArea.toString().replace(',', '.');
      this.object.bD_FlatArea = Number(bdflatAreathis);
    }

    this.serverService.setObject(this.object).then(
      (res) => {
        this.isSetObject = true;
        this.updateLoading = false;
        this.object.id = res;
        this.getObject(this.object);
        this.toastr.success('Изменения сохранены!', 'Успешно!');
        return this.router.navigate(['/main', 'object', res, 'information']);
      },
      (err: any) => {
        if (err.status == 400) {
          this.updateLoading = false;
        }
        if (err.status == 409) {
          this.error409 = true;
          this.updateLoading = false;

        }
        if (err.status == 500 || err.status == 0) {
          this.toastr.error(
            'К сожалению, сервер временно недоступен. Попробуйте повторить действие чуть позже!',
            'Ваши данные не сохранены!'
          );
        }
      }
    );
    this.objectNameLoading = false;
    this.ownInvestmentsLoading = false;
    this.bdInvestmentsLoading = false;
    this.ownInvestmentsLoading2 = false;
    this.bdInvestmentsLoading2 = false;
    this.implementationAmountLoading = false;
    this.durationLoading = false;
  }

  cancel() {
    return this.router.navigate(['/main']);
  }

  calculate(v1: number, v2: number) {
    let t1 = 0;
    let t2 = 0;
    if (v1) {
      t1 = Number(v1.toString());
    }
    if (v2) {
      t2 = Number(v2.toString());
    }
    return t1 + t2;
  }

  calculateCostprice(v1: number, v2: number) {
    let t1 = 0;
    let t2 = 1;
    let t3 = 0;
    if (v1) {
      t1 = parseInt(v1.toString());
    }
    if (v2) {
      t2 = parseInt(v2.toString());
    }
    t3 = t1 / t2;
    return t3;
  }

  calculatePercent(v1: number, v2: number) {
    let t1 = 0;
    let t2 = 0;
    if (v1) {
      t1 = parseInt(v1.toString());
    }
    if (v2) {
      t2 = parseInt(v2.toString());
    }
    return t1 * t2 / 100;
  }

  calculateEconomy() {
    let fact = 0;
    let plan = 0;

    if (this.object.investments.own_investments2 + this.object.investments.bd_investments2 != 0) {
      fact = this.calculate(this.object.investments.own_investments2, this.object.investments.bd_investments2);
    }

    if (this.object.investments.own_investments + this.object.investments.bd_investments != 0) {
      plan = this.calculate(this.object.investments.own_investments, this.object.investments.bd_investments);
    }

    if (plan != 0 && fact != 0) {
      return plan - fact;
    } else {
      return '-';
    }
  }

  file1 = null;
  file2 = null;
  documentNumber: any = 0;
  docLog: boolean = false;

  uploadDocument(event: Event, fileTypeId: number) {
    if (fileTypeId === 1) {
      this.file1 = event;
    }

    if (fileTypeId === 2) {
      this.file2 = event;
    }
    if (fileTypeId === 7) {
      this.file7 = event;
    }

    this.object.docs.map((r) => {
      if (r.documentTypeID === 6) {
        this.documentNumber = r.documentNumber;
      }
    });
    let files = (event.target as HTMLInputElement).files;
    for (let i = 0; i < files.length; i++) {
      let fileType = files[i].type.substr(files[i].type.indexOf('/') + 1);
      this.serverService.uploadObjectDocument(this.object.id, fileType, files[i], fileTypeId).then((res) => {
        if (res.length > 0) {

          if (fileTypeId === 6) {
            this.file6 = event;
            this.serverService.setLivingComplexDocumentNumber(res[0], this.documentNumber).then();
          }
          this.object.docs.push({
            dbFileID: res[0],
            documentTypeID: fileTypeId,
            fileExtension: '',
            fileName: res[0] + '.' + fileType,
            updatedOn: ''
          });
        }


      });
    }
  }

  // uploadDocument(file, fileTypeId: number) {
  //   let fileToUpload = <File>file.item(0);
  //   let fileType = fileToUpload.type.substr(fileToUpload.type.indexOf('/') + 1);
  //   this.serverService.uploadObjectDocument(this.object.id, fileType, fileToUpload, fileTypeId).then(res => {
  //     this.object.docs.push({
  //       dbFileID: res,
  //       documentTypeID: fileTypeId,
  //       fileExtension: '',
  //       fileName: res + "." + fileType,
  //       updatedOn: ''
  //     })
  //   });
  // }
  document;

  deleteDocument(doc) {
    // if (!confirm("Вы уверены, что хотите удалить прикрепленный документ?"))
    //   return false;
    // this.serverService.deleteObjectDocument(doc.dbFileID).then(res => {
    //   let find = this.object.docs.filter(d => d.dbFileID == doc.dbFileID);
    //   if (find) {
    //     let index = this.object.docs.indexOf(find[0]);
    //     this.object.docs.splice(index, 1);
    //   }
    // });

    this.document = doc;
    this.openConfirmDialog = true;
    this.deleteType = 'file';
  }

  deleteDocumentAct(doc) {
    this.document = doc;
    this.openConfirmDialog = true;
    this.deleteType = 'fileAct';
  }

  findDocByTypeId(typeId: number) {
    if (this.object && this.object.docs && this.object.docs.length > 0) {
      let file = this.object.docs.find((d) => d.documentTypeID == typeId);
      if (file) {
        return file;
      } else {
        return null;
      }
    } else {
      return null;
    }
  }

  mioAdmin: IRegion;
  showMioAdmin: boolean = false;

  selectRegionAdmin(adminMio: IRegion) {
    this.showMioAdmin = true;
    this.mioAdmin = adminMio;
  }

  calculateParagh(numb1: number, numb2: number, numb3: number, numb4?: number) {
    let t1 = 0;
    let t2 = 0;
    let t3 = 0;
    let t4 = 0;

    if (numb1) {
      t1 = parseInt(numb1.toString());
    }
    if (numb2) {
      t2 = parseInt(numb2.toString());
    }
    if (numb3) {
      t3 = parseInt(numb3.toString());
    }
    if (numb4) {
      t4 = parseInt(numb4.toString());
    }
    return t1 + t2 + t3 + t4;
  }

  landPlotTypeBtn(log) {
    if (log === false) {
      this.landPlotType = false;
    }
    if (log === true) {
      this.landPlotType = true;
    }
  }

  selectCurator(courator: ICurator) {
    // console.log(`=== before || this.object.curators = `, JSON.parse(JSON.stringify(this.object.curators)));
    this.object.curators.push(courator);
    this.object.curators = this.getUniqueObjectCurators(this.object.curators);

    this.developerModal = false;
    // console.log(`=== after || this.object.curators = `, JSON.parse(JSON.stringify(this.object.curators)));

    // TODO: удалить после завершения разработки
    // this.serverService.setCourator(this.object.id, courator.userId).then((r) => {
    // 	this.uniqueCurators.push(courator);
    // });
  }

  downloadReport() {
    this.serverService.downloadReport(null, null, this.object.id);
  }

  refreshPage() {
    location.reload();
    this.error409 = false;
  }

  cancelRefresh() {
    this.error409 = false;
  }

  downloadDocument(fileID: number, name: string) {
    this.serverService.downloadDocument(fileID).subscribe(response => {
      this.downLoadFile(response, name);
    });
  }

  downLoadFile(data: any, name: string) {
    let fileName = name.split('.')[0];
    var a = document.createElement("a");
    const blob = new Blob([data], {type: 'application/pdf'});

    a.href = URL.createObjectURL(blob);
    a.download = fileName;
    a.click();
  }

  openMapDialog() {
    this.dialog.open(LeafletDialogComponent, {
      maxWidth: '900px',
      maxHeight: '600px',
      width: '900px',
      height: '600px',
      data: {
        latitude: this.object.latitude,
        longitude: this.object.longitude
      },
      autoFocus: false
    }).afterClosed().subscribe((res: IMapControlResult) => {
      if (res) {
        this.object.latitude = res.latitude;
        this.object.longitude = res.longitude;
      }
    });
  }

  get checkKenmlAmount() {
    return this.object.kenmlAmount > this.object.estimateCost;
  }

}
